import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['searchPhase', 'confirmPhase', 'itemIdInput', 'nameInput'];

  select(event) {
    const el = event.currentTarget;
    this.itemIdInputTarget.value = el.dataset.itemId || '';
    this.nameInputTarget.value = el.dataset.itemName || '';

    this.searchPhaseTarget.classList.add('d-none');
    this.confirmPhaseTarget.classList.remove('d-none');
  }

  back(event) {
    event.preventDefault();
    this.searchPhaseTarget.classList.remove('d-none');
    this.confirmPhaseTarget.classList.add('d-none');
    this.itemIdInputTarget.value = '';
    this.nameInputTarget.value = '';
  }

  clearFrame(event) {
    event.preventDefault();
    const frame = document.getElementById('google_drive_add_favorite');
    if (!frame) return;
    while (frame.firstChild) {
      frame.removeChild(frame.firstChild);
    }
  }
}
